/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Deep_P1Inputs */

const en_to_csv_deep_p1 = /** @type {(inputs: To_Csv_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A field is wrapped in double quotes only when it has to be, which is when it contains a comma, a double quote, or a newline. Inside a quoted field, each double quote is doubled, so the value said "hi" becomes the field with doubled inner quotes. Everything else is written bare, which keeps the output readable and diffable rather than uniformly quoted.`)
};

const ko_to_csv_deep_p1 = /** @type {(inputs: To_Csv_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`필드는 꼭 필요할 때만 큰따옴표로 감쌉니다. 쉼표, 큰따옴표, 줄바꿈을 담고 있을 때입니다. 인용된 필드 안에서는 각 큰따옴표가 두 개로 늘어나므로, said "hi"라는 값은 안쪽 따옴표가 두 개가 된 필드로 바뀝니다. 그 밖의 것은 그대로 작성되어, 전부 인용하는 방식보다 출력을 읽고 비교하기 쉽게 유지합니다.`)
};

const ja_to_csv_deep_p1 = /** @type {(inputs: To_Csv_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フィールドは必要なときだけ二重引用符で囲まれます。カンマ、二重引用符、改行を含むときです。引用されたフィールドの中では各二重引用符が 2 つに増えるので、said "hi" という値は内側の引用符が 2 つになったフィールドになります。それ以外は裸で書かれ、一律に引用する方式より出力を読みやすく差分も取りやすく保ちます。`)
};

/**
* | output |
* | --- |
* | "A field is wrapped in double quotes only when it has to be, which is when it contains a comma, a double quote, or a newline. Inside a quoted field, each doub..." |
*
* @param {To_Csv_Deep_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_deep_p1 = /** @type {((inputs?: To_Csv_Deep_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Deep_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_deep_p1(inputs)
	if (locale === "ko") return ko_to_csv_deep_p1(inputs)
	return ja_to_csv_deep_p1(inputs)
});